// extracted by mini-css-extract-plugin
export default {"stacked-files":"HGAkGY"};